import { Component } from '@angular/core';
import { NotificationsService } from 'src/app/core/service/notifications.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent {

  constructor(
    private notificationsService: NotificationsService,
  ) { }

  onSuccess() {
    this.notificationsService.success({
      title: 'Success',
      message: 'The operation was successful.',
    });
  }

  onError() {
    this.notificationsService.error({
      title: 'Error',
      message: 'Something went wrong, please try again.',
    });
  }

  onWarning() {
    this.notificationsService.warning({
      title: 'Warning',
      message: 'Place warning message here.',
    });
  }

  onInfo() {
    this.notificationsService.info({
      title: 'Info',
      message: 'Place info message here.',
    });
  }

}
